import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { RichTextEditor } from "./RichTextEditor";
import { BookOpen } from "lucide-react";

export const hasGuide = (b) => !!(b.description_html || "").replace(/<p><\/p>/g, "").trim();

export const BehaviorGuideButton = ({ behavior, strategyName }) => {
  const [open, setOpen] = useState(false);
  if (!hasGuide(behavior)) return null;
  return (
    <>
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
        className="shrink-0 h-5 w-6 flex items-center justify-center border border-zinc-900 hover:bg-zinc-900 hover:text-white transition-colors"
        title="Handleiding bekijken"
        data-testid={`behavior-guide-button-${behavior.id}`}
      >
        <BookOpen className="h-3 w-3" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-none max-w-4xl max-h-[90vh] overflow-y-auto" data-testid="behavior-guide-dialog">
          <DialogHeader>
            <div className="font-mono text-[11px] uppercase tracking-widest text-zinc-500">{strategyName} · handleiding</div>
            <DialogTitle className="font-grotesk text-2xl leading-tight">{behavior.text}</DialogTitle>
            <DialogDescription>Alleen lezen. Bewerken kan op het scherm Strategieën.</DialogDescription>
          </DialogHeader>
          <div className="border-t border-zinc-200 pt-4">
            {open && <RichTextEditor value={behavior.description_html} editable={false} />}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
